<script>
	import Container from "./Container.svelte"
</script>
<body>
	<head>
		<title>Calculator</title>
	</head>
	
		<Container />
	
</body>
<style>
	body {
		background-color: white ;
	/*	background-color: #2a2a72;
	background-image: linear-gradient(315deg, #2a2a72 0%, #009ffd 74%); */
	padding: 0px; 
	}
	
</style>